import React from "react";

import styles from "./DocumentViewer.module.css";

export const DocumentViewer = ({ imageData, isImage, fileName, fileType }) => {
  if (isImage) {
    return (
      <div className={styles.viewerContainer}>
        <div className={styles.imageContainer}>
          <img
            src={imageData}
            alt="Document Preview"
            className={styles.previewImage}
            crossOrigin={
              imageData && imageData.startsWith("http")
                ? "anonymous"
                : undefined
            }
            referrerPolicy={
              imageData && imageData.startsWith("http")
                ? "no-referrer"
                : undefined
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.unsupportedContainer}>
      <p className={styles.unsupportedText}>
        Cannot preview <strong>{fileType}</strong> files. Please download{" "}
        <strong>{fileName}</strong>
      </p>
    </div>
  );
};
